import React from 'react'
import { Carousel, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import Speaker1 from '../../images/event/speaker1.jpg'
import Speaker2 from '../../images/event/speaker2.jpg'
import Speaker3 from '../../images/event/speaker3.jpg'
import Speaker4 from '../../images/event/speaker4.jpg'
import Speaker5 from '../../images/event/speaker5.jpg'
import { COLORS, SIZES } from '../../styles/theme'

const StyledModal = styled(Modal)`
  .modal-content {
    box-shadow: 0px 4px 12px ${COLORS.lightGray1};
  }
  .modal-body {
    padding: 0;
  }
`

const StyledCarousel = styled(Carousel)`
  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-prev {
    left: -10%;
    ${SIZES.mobile} {
      left: -5%;
    }
  }
  .carousel-control-next {
    right: -10%;
    ${SIZES.mobile} {
      right: -5%;
    }
  }

  .carousel-control-next-icon:after {
    color: ${COLORS.primaryTrans};
  }

  .carousel-control-prev-icon:after {
    color: ${COLORS.primaryTrans};
  }
`

const speakerList = [
  {
    id: 1,
    image: Speaker1,
  },
  {
    id: 2,
    image: Speaker2,
  },
  {
    id: 3,
    image: Speaker3,
  },
  {
    id: 4,
    image: Speaker4,
  },
  {
    id: 5,
    image: Speaker5,
  },
]

export default function SpeakersModal({ showModal, hideSchedule }) {
  return (
    <StyledModal show={showModal} onHide={hideSchedule} size="lg" aria-labelledby="speakers-bio" centered>
      <Modal.Body>
        <StyledCarousel>
          {speakerList.map((speaker, index) => (
            <Carousel.Item key={`speaker-${index}`} interval={4000}>
              <img className="d-block w-100" src={speaker.image} alt={`speaker-${index}`} />
            </Carousel.Item>
          ))}
        </StyledCarousel>
      </Modal.Body>
    </StyledModal>
  )
}
